module.exports = __webpack_public_path__ + "assets/-_8.a908a0e1.svg";